export default "__VITE_ASSET__af058094__"